<template>
  <div style="display: contents;">
    <tr>
      <td>
        <b-checkbox
          v-model="checkboxModel"
          :disabled="!element.is_optional"
          :indeterminate="checkboxIndeterminate"
          @change="onCheckboxChange"
        >
          <small>{{ element.label }}</small>
        </b-checkbox>
      </td>
      <td nowrap><small>{{ element.start_date }} - {{ element.end_date }}</small></td>
      <th
        class="text-center"
        :style="avaStyle"
        :title="avaDesc" >{{ avaLabel }}</th>
      <td class="text-danger" nowrap>
        <small>
          <template v-if="element.is_optional">
            {{ price.toFixed(2) }} {{ currency }}
          </template>
          <template v-else>
            inclus
          </template>
        </small>
      </td>
      <td nowrap class="text-center">
        <span v-if="element.has_outbound_seat_map" v-b-tooltip.hover title="Diagrama locuri outbound">
          <b-iconstack
            variant="primary"
            style="cursor: pointer;"
            :class="{
              'mr-2': element.has_outbound_seat_map || displayPaxToggler
            }"
            @click="toggleSeatMap('out')">
            <b-icon stacked icon="diagram2-fill" shift-v="-3" />
            <b-icon stacked icon="chevron-up" shift-v="10" scale="0.75" />
          </b-iconstack>
        </span>
        <small v-if="element.has_inbound_seat_map" v-b-tooltip.hover title="Diagrama locuri Inbound">
          <b-iconstack
            variant="primary"
            style="cursor: pointer;"
            :class="{
              'mr-2': displayPaxToggler
            }"
            @click="toggleSeatMap('out')">
            <b-icon stacked icon="diagram2-fill" shift-v="3" flip-h flip-v />
            <b-icon stacked icon="chevron-down" shift-v="-10" scale="0.75" />
          </b-iconstack>
        </small>
        <small v-if="displayPaxToggler"><b-icon variant="primary" style="cursor: pointer;" icon="caret-down-fill" @click="togglePax()" /></small>
      </td>
    </tr>
    <template v-if="showPax">
      <template v-for="(room, roomIndex) in pax">
        <template v-for="(p, paxIndex) in room">
          <ElementPax
            :pax="p"
            :roomIndex="roomIndex"
            :paxIndex="paxIndex"
            :currency="currency"
            :paxPrices="element.pax_prices"
            :checked="isChecked(roomIndex, paxIndex)"
            @change="onPaxSelectionChange($event, roomIndex, paxIndex)"
            :key="'pax_' + roomIndex + '_' + paxIndex" />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

import availability from '@/app/private/shared/availability'
import ElementPax from './element_pax'

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: {
    ElementPax
  },
  data () {
    const paxCheckboxes = []
    this.pax.forEach(room => {
      room.forEach(pax => {
        paxCheckboxes.push(this.checked)
      })
    })
    return {
      showPax: false,
      checkboxIndeterminate: false,
      checkboxModel: this.checked,
      paxCheckboxes
    }
  },
  computed: {
    price () {
      return this.element.price.gross + this.element.price.tax
    },
    startDate () {
      return moment(this.element.start_date).format('DD/MMM')
    },
    endDate () {
      return moment(this.element.end_date).format('DD/MMM')
    },
    availability () {
      return availability.find(el => el.name === this.element.availability)
    },
    avaLabel () {
      return this.availability.shortLabel
    },
    avaDesc () {
      return this.availability.label
    },
    avaStyle () {
      return { color: this.availability.colour }
    },
    displayPaxToggler () {
      return this.element.application_model === 'per pax' && this.element.is_optional
    }
  },
  methods: {
    togglePax () {
      this.showPax = !this.showPax
    },
    onPaxSelectionChange ($event, roomIndex, paxIndex) {
      if (this.element.application_model === 'per pax') {
        this.element.pax[roomIndex][paxIndex] = $event
        const someChecked = this.element.pax.some(room => room.some(pax => pax))
        const someUnchecked = this.element.pax.some(room => room.some(pax => !pax))
        this.$emit('change', someChecked)
        this.checkboxIndeterminate = someChecked && someUnchecked
      }
    },
    onCheckboxChange (value) {
      const paxCheckboxes = []
      if (value) {
        this.element.pax.forEach((room, roomIndex) => {
          room.forEach((pax, paxIndex) => {
            this.element.pax[roomIndex][paxIndex] = true
            paxCheckboxes.push(true)
          })
        })
      } else {
        this.element.pax.forEach((room, roomIndex) => {
          room.forEach((pax, paxIndex) => {
            this.element.pax[roomIndex][paxIndex] = false
          })
        })
      }
      this.paxCheckboxes = paxCheckboxes
      this.$emit('change', this.checkboxModel)
    },
    isChecked (roomIndex, paxIndex) {
      let realIndex = 0
      this.pax.forEach((room, index) => {
        if (index < roomIndex) {
          realIndex += room.length
        }
      })
      realIndex += paxIndex
      return this.paxCheckboxes[realIndex]
    },
    toggleSeatMap (direction) {
      this.$emit('toggleSeatMap', { direction, index: this.index })
    }
  },
  watch: {
    checked (value) {
      this.checkboxModel = value
    }
  }
}
</script>
